export default __webpack_public_path__ + "static/media/rep_6.c51ca5d0.mp3";